import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { CardFaceStyle } from '../components/CardFace.js';

/**
 * Card FACE layout: one per-device preference for every card game. `pips` is the traditional face
 * (ten hearts on the 10 of hearts); `bold` is one big suit in the middle, easier to read small.
 * Court cards and aces look the same in both. The default is `pips`.
 */
export const CARD_FACE_STYLES: readonly CardFaceStyle[] = ['pips', 'bold'];

export const CARD_FACE_NAMES: Record<CardFaceStyle, string> = { pips: 'Classic pips', bold: 'Big suit' };

interface CardFaceStore {
  readonly style: CardFaceStyle;
  setStyle(style: CardFaceStyle): void;
}

export const useCardFaceStore = create<CardFaceStore>()(
  persist(
    (set) => ({
      style: 'pips',
      setStyle(style) {
        set({ style });
      },
    }),
    { name: 's4k:card-face' },
  ),
);
